<small *ngIf="capsLocked()" class="inline-flex items-center gap-2 text-sky-700">
  <ng-icon name="phosphorArrowFatLineUp" class="text-xl text-primary"></ng-icon>
  <span i18n>Your caps lock is on!</span>
</small>
